import URLPattern from 'url-pattern';
import { AuthenticatedRoute } from '../types/auth';

export const authenticatedRoutes: AuthenticatedRoute[] = [
  //a
  new URLPattern('/alerting/notification-types'),
  new URLPattern('/alerting/users/(:userId)'),
  //b
  new URLPattern('/billing-service/company-preferences/(:companyId)'),
  new URLPattern('/billing/is-company-tax-exempt/(:companyId)'),
  //c
  new URLPattern('/company/utilization'),
  new URLPattern('/company/aggregated-utilization'),
  new URLPattern('/company-documents-service/companies/(:companyId)/documents'),
  new URLPattern(
    '/company-documents-service/companies/(:companyId)/documents/(:documentId)/download',
  ),
  new URLPattern('/companies/(:companyId)/rentals'),
  new URLPattern('/companies/(:companyId)/rentals/(:rentalId)'),
  new URLPattern('/companies/(:companyId)/purchase-orders'),
  new URLPattern('/companies/(:companyId)/credit-applications'),
  new URLPattern('/companies/(:companyId)/credit-applications/(:applicationId)'),
  new URLPattern('/companies/(:companyId)/purchase-orders/(:orderId)'),
  new URLPattern('/companies/(:companyId)/locations'),
  {
    url: new URLPattern('/companies/(:companyId)'),
    isRequiredForSettingAuthState: true,
  },
  new URLPattern('/companies/(:companyId)/users'),
  {
    url: new URLPattern('/companies/(:companyId)/users/(:userId)'),
    isRequiredForSettingAuthState: true,
  },
  new URLPattern('/contracts/(:contractId).(:suffix)'),
  //o
  new URLPattern('/orders/(:orderId)/contracts'),
  //r
  new URLPattern('/rental-cart-service/companies/(:companyId)/user/(:userId)/rental-preferences'),
  new URLPattern('/rentals/(:rentalId)'),
  new URLPattern('/rentals/(:rentalId)/notes'),
  new URLPattern('/rentals/(:rentalId)/cancel-off-rent'),
  new URLPattern('/rental-order-service/rental-requests'),
  {
    url: new URLPattern('/rental-order-service/rental/request'),
    authTokenOptional: true,
  },
  {
    url: new URLPattern('/rental-order-service/calculate_quote'),
    authTokenOptional: true,
  },
  {
    url: new URLPattern('/rental-rates/multiple'),
    authTokenOptional: true,
  },
  new URLPattern('/rsp/locations'),
  new URLPattern('/rsp/locations/(:locationId)'),
  //s
  new URLPattern('/signup/companies/(:companyId)/userInvitations'),
  new URLPattern('/signup/companies/(:companyId)/userInvitations/(*)'),
  //u
  new URLPattern('/user'),
  new URLPattern('/users/(:userId)'),
  new URLPattern('/users/(:userId)/message-settings'),
];
